import React from 'react';
import { Box, Typography } from "@mui/material";
import { helpContent } from './content';
import { HelpContent } from './content/siteAccessPolicies';

// Helper function to convert help content data to JSX
const renderHelpContent = (content: HelpContent): React.ReactNode => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>
                Overview
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
                {content.overview}
            </Typography>

            {content.sections.map((section, index) => (
                <React.Fragment key={index}>
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {section.title}
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                        {section.content.map((item, itemIndex) => (
                            <Typography component="li" variant="body2" sx={{ mb: 0.5 }} key={itemIndex}>
                                {item.includes(':') ? (
                                    <>
                                        <strong>{item.split(':')[0]}:</strong>
                                        {item.split(':').slice(1).join(':')}
                                    </>
                                ) : (
                                    item
                                )}
                            </Typography>
                        ))}
                    </Box>
                </React.Fragment>
            ))}
        </Box>
    );
};

// Helper function to get help content for a specific route
export const getHelpContent = (route: string): React.ReactNode => {
    const content = helpContent[route as keyof typeof helpContent];
    if (!content || typeof content === 'string') return null;
    
    return renderHelpContent(content as HelpContent);
}; 